export const renderTitleDescription = (title, description) => {
  return (
    <div className="flex flex-col gap-2 text-center w-full px-4">
      {title && <p className="text-[clamp(24px,3vw,40px)] font-semibold">{title}</p>}
      {description && (
        <p className="text-[clamp(14px,2vw,24px)] font-normal text-grey-700">{description}</p>
      )}
    </div>
  );
};
